import SimpleTable from './SimpleTable';

export default SimpleTable;
